import React, { useEffect, useRef, useState } from 'react';
import container1 from '../../assets/container7.png';
import container2 from '../../assets/container_sec4.png';
import buttonEarn from '../../assets/button_4.png';
import button2 from '../../assets/button5.png';
import { useNavigate } from 'react-router-dom';

import './ContSection.css';

const ContSection = () => {
  const navigate = useNavigate();

  // Tracks which slide is currently active (0 or 1)
  const [activeIndex, setActiveIndex] = useState(0);

  // Reference to the horizontal scroll container
  const scrollRef = useRef(null);

  const handleButtonClick = () => {
    navigate('/purchase');
  };

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleScroll = () => {
      const scrollLeft = container.scrollLeft;
      const width = container.offsetWidth;

      // Determine which slide is most visible
      const index = Math.round(scrollLeft / width);
      setActiveIndex(index);
    };

    container.addEventListener('scroll', handleScroll, { passive: true });

    // Initial calculation (important on load / resize)
    handleScroll();

    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="cont-section">
      <div
        className="cont-scroll-container"
        ref={scrollRef}
      >
        <div
          className="cont-sec-image"
          data-aos="fade-right"
          data-aos-duration="700"
          data-aos-once="true"
        >
          <img
            className="main-image"
            draggable="false"
            src={container1}
            alt="First"
          />
          <button className="image-button" onClick={handleButtonClick}>
            <img src={buttonEarn} alt="Button" draggable="false" />
          </button>
        </div>

        <div
          className="cont-sec-image"
          data-aos="fade-left"
          data-aos-duration="700"
          data-aos-once="true"
        >
          <img
            className="main-image"
            draggable="false"
            src={container2}
            alt="Second"
          />
          <button className="image-button" onClick={handleButtonClick}>
            <img src={button2} alt="Button" draggable="false" />
          </button>
        </div>
      </div>

      {/* Indicators */}
      <div className="cont-indicators">
        <div className={`cont-indicator ${activeIndex === 0 ? 'active' : ''}`} />
        <div className={`cont-indicator ${activeIndex === 1 ? 'active' : ''}`} />
      </div>
    </div>
  );
};

export default ContSection;
